import React, { useState } from "react";
import PropTypes from "prop-types";
import { CiViewList } from "react-icons/ci";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { BsPerson } from "react-icons/bs";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import { GoGear } from "react-icons/go";
import { VscListFilter } from "react-icons/vsc";
const Lists = () => {
  const [onClick, setOnCLick] = useState(false);
  const [onSearching, setSearching] = useState(false);
  const onClickHandler = (e) => {
    setOnCLick(!onClick);
  };
  const selectHandler = () => {
    setSearching(!onSearching);
  };
  return (
    <div
      className={`${
        onClick ? "flex flex-col border-blue-700 border mr-1 h-auto" : ""
      }`}
    >
      <button
        onClick={onClickHandler}
        className="flex flex-row justify-between w-full hover:bg-gray-100"
      >
        <div className="flex items-center px-2 h-12 hover:text-blue-600 font-medium">
          <CiViewList />
          <div className="ml-2 text-sm">Lists</div>
        </div>
        <div className="m-4">
          {!onClick ? (
            <FaCaretDown className="text-gray-500" />
          ) : (
            <FaCaretUp className="text-gray-500" />
          )}
        </div>
      </button>
      {onClick && (
        <>
          <div className="flex pt-2 justify-between">
            <div className="flex border-b hover:border-b-blue-600 w-full flex-row px-2 justify-center items-center ">
              <div className="flex mb-2 items-center hover:text-blue-500 font-semibold">
                <BsPerson />
                <p className="ml-2 text-sm">People</p>
              </div>
            </div>
            <div className="flex w-full flex-row px-2 border-b hover:border-b-blue-600 justify-center ">
              <div className="flex mb-2 items-center hover:text-blue-500 font-semibold">
                <HiOutlineBuildingOffice />
                <p className="ml-2 text-sm">Companies</p>
              </div>
            </div>
          </div>
          <div className="font-semibold">
            <div className="flex flex-row justify-between items-center px-2">
              <div className="flex items-center text-[12px]">
                <GoGear className="text-[10px] mr-1" /> Include lists
              </div>
              <div className="flex items-center text-[12px]">
                <VscListFilter className="text-[10px] mr-1" /> Most Recent
              </div>
            </div>
            <div className="px-3">
              <button
                onClick={selectHandler}
                className="flex w-full justify-between items-center p-1 rounded border border-gray-300 hover:border-blue-700 hover:pointer"
              >
                <p className="text-gray-500 font-normal text-sm">
                  Select lists...
                </p>
                <FaCaretDown className="text-gray-500" />
              </button>
              {onSearching && (
                <div className="w-full border mt-2 rounded bg-white">
                  <div className="flex mt-1 h-[50px] relative">
                    <button className="flex items-center hover:text-blue-500 border-collapse hover:border-b hover:border-b-blue-600 justify-center w-full">
                      <CiViewList /> <p className="mx-1 text-sm">All</p>
                    </button>
                    <button className="flex items-center hover:text-blue-500 border-collapse hover:border-b hover:border-b-blue-600 justify-center w-full">
                      <BsPerson />
                      <p className="mx-1 text-sm">My</p>
                    </button>
                    <button className="flex items-center hover:text-blue-500 border-collapse hover:border-b hover:border-b-blue-600 justify-center w-full">
                      <HiOutlineBuildingOffice />
                      <p className="mx-1 text-sm">Team</p>
                    </button>
                  </div>
                  <p className="text-[12px] text-gray-400 m-2">No results found</p>
                </div>
              )}
            </div>
            <div className="mx-3 my-4 flex items-center text-sm">Advance setting <FaCaretDown/></div>
          </div>
        </>
      )}
      <hr />
    </div>
  );
};

Lists.propTypes = {
  status: PropTypes.string,
};

export default Lists;
